/* eslint-disable */
import 'babel-polyfill' // 解决ie浏览器不支持promise
import Vue from 'vue'
import App from './App'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.less'
import './styles/logo.less'
import store from './store/index'
import './tools/request'
import VueCookies from 'vue-cookies'
import animate from 'animate.css'
import VueParticles from 'vue-particles'
import  Blob from './vendor/Blob'
import  Export2Excel from './vendor/Export2Excel'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(VueParticles)
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js